import { NgClass } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RCP_DIALOG_ITEMS } from '@app/constants/RCP_DIALOG_ITEMS';
import { AlertType } from '@app/enums/alert-type.enum';
import { AppStore } from '@app/stores/app/app.store';
import type { IModalMessageData } from '@app/types/modal-data';
import { DynamicActionsComponent } from '../../dynamic-actions/dynamic-actions.component';

@Component({
    selector: 'app-message-dialog',
    imports: [
        RCP_DIALOG_ITEMS,
        MatButtonModule,
        MatIconModule,
        NgClass,
        DynamicActionsComponent,
    ],
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss'],
})
export class MessageDialogComponent implements OnInit {
    private appStore = inject(AppStore);
    translate = this.appStore.i18n;
    readonly alertTypes: Record<AlertType, string> = {
        [AlertType.Success]: 'check',
        [AlertType.Warning]: 'warning',
        [AlertType.Info]: 'info',
        [AlertType.Error]: 'report',
        [AlertType.None]: 'none',
    };

    readonly alertType = AlertType;
    readonly data = inject<IModalMessageData>(MAT_DIALOG_DATA);
    readonly dialogRef = inject(MatDialogRef);

    readonly leftActions = this.data.actions?.filter(
        (action) => action.alignment === 'left',
    );
    readonly rightActions = this.data.actions?.filter(
        (action) => action.alignment === 'right' || !action.alignment,
    );

    showAlertType = signal(false);

    ngOnInit(): void {
        this.showAlertType.set(this.data.alertType != AlertType.None);
    }

    onOkClick(e: Event) {
        e.preventDefault();
        this.dialogRef.close();
    }
}
